import createAction from 'redux-actions/es/createAction';

import { FETCH_PRODUCT } from './consts/types';

export { findProductById } from '@esentai/core/features/products/actions';

export const fetchProduct = createAction(FETCH_PRODUCT);
